export { default } from './index.vue'



// WEBPACK FOOTER //
// ./packages/dof-divider/index.js